import React, { forwardRef } from 'react'

import { BackToTop } from '@Components/BackToTop'
import { SinglePostWrap } from '@Components/CMS/SinglePostWrap'
import { FooterWithGroupVisibility } from '@Components/Footer'
import { HeaderWithGroupVisibility } from '@Components/Header'
import { OneColumn } from '@Layouts/OneColumn'

interface CMSPageProps {
  children?: React.ReactNode
  withoutBackToTop?: boolean
}
export const CMSPage = forwardRef<HTMLDivElement | null, CMSPageProps >(({ children, withoutBackToTop }, ref) => (
  <>
    <OneColumn footer={<FooterWithGroupVisibility />} header={<HeaderWithGroupVisibility />}>
      <SinglePostWrap ref={ref}>
        {children}
      </SinglePostWrap>
    </OneColumn>
    {!withoutBackToTop && <BackToTop />}
  </>
))
